import startOfWeek from "date-fns/startOfWeek";
import nextMonday from "date-fns/nextMonday";
import isWeekend from "date-fns/isWeekend";

export function beginAndEndOfNextWeek() {
  const today = new Date();

  const monday = isWeekend(today)
    ? nextMonday(today)
    : nextMonday(startOfWeek(today));
  monday.setHours(0, 0, 0, 0);

  const friday = new Date(monday);
  friday.setDate(friday.getDate() + 4);
  friday.setHours(23, 59, 59, 999);

  return [monday, friday];
}
